<template>
    <div class="simple-form">
        <el-form :model="authMsuInfo" :rules="authMsuInfoRules" :label-position="'left'" ref="authMsuInfoRule">
            <div class="form-group">
                <div class="form-label">
                    <label class="required">授权开始时间</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="distDateFrom">
                        <el-date-picker v-model="authMsuInfo.distDateFrom" type="date" placeholder="开始日期"></el-date-picker>
                    </el-form-item>
                </div>
            </div>
            <div class="form-group">
                <div class="form-label">
                    <label class="required">授权截止时间</label>
                </div>
                <div class="form-value">
                    <el-form-item prop="distDateTo">
                        <el-date-picker v-model="authMsuInfo.distDateTo" type="date" placeholder="截止日期"></el-date-picker>
                    </el-form-item>
                </div>
            </div>
            <div v-if="!addAuthTime">
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">工时费(元)</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="workHourFee">
                            <el-input class="width-1-5x" type="number" v-model="authMsuInfo.workHourFee"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">上门费(元)</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="toDoorFee">
                            <el-input class="width-1-5x" type="number" v-model="authMsuInfo.toDoorFee"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">服务费(元)</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="generallFee">
                            <el-input class="width-1-5x" type="number" v-model="authMsuInfo.generallFee"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">质保期(天)</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="wrntPeriod">
                            <el-input class="width-1-5x" type="number" v-model="authMsuInfo.wrntPeriod"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">响应时长(分)</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="rspTimeMi">
                            <el-input class="width-1-5x" type="number" v-model="authMsuInfo.rspTimeMi"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">到达时长(分)</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="arriveTimeMi">
                            <el-input class="width-1-5x" type="number" v-model="authMsuInfo.arriveTimeMi"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">修复时长(分)</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="repairedTimeMi">
                            <el-input class="width-1-5x" type="number" v-model="authMsuInfo.repairedTimeMi"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label class="required">回询时限(分)</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="telCallTimeMi">
                            <el-input class="width-1-5x" type="number" v-model="authMsuInfo.telCallTimeMi"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>配件名称</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="accName">
                            <el-input class="width-1-5x" type="text" v-model="authMsuInfo.accName"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>配件规格</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="accSpec">
                            <el-input class="width-1-5x" type="text" v-model="authMsuInfo.accSpec"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>价格下限(元)</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="accPrice">
                            <el-input class="width-1-5x" type="number" v-model="authMsuInfo.accPrice"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-label">
                        <label>价格上限(元)</label>
                    </div>
                    <div class="form-value">
                        <el-form-item prop="accPrice2">
                            <el-input class="width-1-5x" type="number" v-model="authMsuInfo.accPrice2"></el-input>
                        </el-form-item>
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'
    import { openAuthServicerForSelectDlg } from '../servicer/selectDlg'

    import servcApi from '../../api/servc'

    export default {
        name: 'swb-auth-out-msu-update',
        desc: '授权服务-编辑',
        props: ['id', 'addAuthTime'],
        data: function () {
            let self = this;
            let checkDateStart = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('授权开始时间不能为空!'));
                } else {
                    callback();
                }
            };
            let checkDateEnd = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    return callback(new Error('授权截止时间不能为空!'));
                } else if(value.format("yyyy-MM-dd") < self.authMsuInfo.distDateFrom.format("yyyy-MM-dd")) {
                    callback(new Error('授权截止时间需大于授权开始时间！'));
                } else if(value.format("yyyy-MM-dd") < new Date().format("yyyy-MM-dd")) {
                    callback(new Error('授权截止时间需大于当前时间！'));
                } else {
                    callback();
                }
            };
            let checkNull = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不可为空'));
                } else {
                    if(!Utils.isNumber(parseFloat(value)) || value <= 0) {
                        callback(new Error('请输入大于0的数'));
                    } else {
                        callback();
                    }
                }
            };
            let validatewrntPeriod = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback();
                } else {
                    if(!Utils.isNumber(value)) {
                        callback(new Error('请输入正确的数'));
                    } else {
                        callback();
                    }
                }
            };
            return {
                authMsuInfo: {
                    distDateFrom: null,
                    distDateTo: null,
                },
                authMsuInfoRules: {
                    distDateFrom: [{validator: checkDateStart, trigger: 'blur'}],
                    distDateTo: [{validator: checkDateEnd, trigger: 'blur'}],
                    toDoorFee: [{validator: checkNull, trigger: 'blur'}],
                    workHourFee: [{validator: checkNull, trigger: 'blur'}],
                    generallFee: [{validator: checkNull, trigger: 'blur'}],
                    wrntPeriod: [{validator: validatewrntPeriod, trigger: 'blur'}],
                    rspTimeMi: [{validator: checkNull, trigger: 'blur'}],
                    arriveTimeMi: [{validator: checkNull, trigger: 'blur'}],
                    repairedTimeMi: [{validator: checkNull, trigger: 'blur'}]
                }
            }
        },
        created: function () {
            //
            this.getMsuInfo();
        },
        methods: {
            getMsuInfo: function () {
                let self = this;
                let params = {
                    id: self.id
                };
                let theLoad = MsgBox.loading();
                servcApi.getMsuInfo(params, function (result) {
                    theLoad.hide();
                    if(result.type == 'info') {
                        //
                        self.authMsuInfo = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                let authMsuInfo = self.authMsuInfo;
                this.$refs['authMsuInfoRule'].validate(function (valid) {
                    if(valid) {
                        result.type = "info";
                        //
                        if(Utils.isNoB(authMsuInfo.accPrice)) {
                            authMsuInfo.accPrice = 0;
                        }
                        if(Utils.isNoB(authMsuInfo.accPrice2)) {
                            authMsuInfo.accPrice2 = 0;
                        }
                        //
                        authMsuInfo.distDateFrom = authMsuInfo.distDateFrom.format("yyyy-MM-dd");
                        authMsuInfo.distDateTo = authMsuInfo.distDateTo.format("yyyy-MM-dd");
                        //
                        result.data = authMsuInfo;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servc/AuthOutMsuUpdate.vue